import { getTranslations } from 'next-intl/server';
import PageContainer from '@/components/layout/page-container';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { IconAlertTriangleFilled } from '@tabler/icons-react';
import { DevToolsTabs } from './dev-tools-tabs';

export async function DevToolsPage() {
  const t = await getTranslations('devTools');

  return (
    <PageContainer pageTitle={t('title')} pageDescription={t('subtitle')}>
      <div className='flex flex-col gap-4'>
        <Alert variant='destructive'>
          <IconAlertTriangleFilled className='size-4' />
          <AlertDescription>{t('warningBanner')}</AlertDescription>
        </Alert>
        <DevToolsTabs />
      </div>
    </PageContainer>
  );
}
